export const ALL_SPECIALITIES = "/speciality/list";
export const ADD_SPECIALITY = "/speciality/add";
export const UPDATE_SPECIALITY = "/speciality/update";
export const DELETE_SPECIALITY = "/speciality/delete";
export const GET_SPECIALITY_BY_ID = "/speciality/detail";
